import React, { useState } from 'react';
import DateRangePicker from './DataRangePicker';

export default function InputForm({
  type,
  text,
  id,
  error = "",
  required = false,
  value = null,
  onChange = () => {},
  onClick = () => {},
  enabled = true,
  AppendClassName = "",
  dateRangeOptions,
  addedRanges = {},
  Icon
}) {
  const [inputType, setInputType] = useState(type);
  const [isDateRangeOpen, setDateRangeOpen] = useState(false);

  const togglePasswordVisibility = () => {
    setInputType(inputType === 'password' ? 'text' : 'password');
  };

  const handleDateRangeClick = () => {
    setDateRangeOpen((prev) => !prev);
  };

  const handleDateRangeChange = (event) => {
    onChange(event);
    setDateRangeOpen(false);
  };

  const visibilityIcon =
    inputType === 'password'
      ? `${process.env.PUBLIC_URL}/svg/visibility_off.svg`
      : `${process.env.PUBLIC_URL}/svg/visibility.svg`;

  return (
    <div className={"relative w-full mb-5 group" + (error ? " animate-shake" : "")}>
      {type === 'datarange' ? (
        // === RANGO DE FECHAS ===
        <button
          type="button"
          onClick={handleDateRangeClick}
          className={
            (error
              ? "block py-3.5 px-4 w-full text-red_error bg-transparent border-2 border-red_error rounded-md appearance-none focus:outline-none focus:ring-0 focus:border-red_error peer"
              : "block py-3.5 px-4 w-full text-gray-900 bg-transparent border-2 border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-0 focus:border-blue-900 peer") +
            " " + AppendClassName
          }
          disabled={!enabled}
        >
          {value}
        </button>
      ) : type === 'color' ? (
        // === INPUT DE COLOR ===
        <div
          className={
            "flex items-center justify-between w-full border-2 rounded-md px-3 py-2 cursor-pointer " +
            (error
              ? "border-red_error text-red_error"
              : "border-gray-300 text-gray-900 focus-within:border-blue-900") +
            " " + AppendClassName
          }
        >
          {/* Cuadro de color */}
          <label htmlFor={id} className="flex items-center gap-3 w-full">
            <div
              className="w-8 h-8 rounded-md border border-gray-300 shadow-sm"
              style={{ backgroundColor: value || "#3B82F6" }}
            />
            {/* Código hexadecimal visible */}
            <span className="text-sm font-medium">{value || "#3B82F6"}</span>
          </label>

          {/* Input de color oculto pero funcional */}
          <input
            type="color"
            id={id}
            name={id}
            value={value || "#3B82F6"}
            onChange={(e) => onChange(e.target.value)}
            disabled={!enabled}
            className="absolute opacity-0 pointer-events-none"
          />
        </div>
      ) : (
        // === INPUT NORMAL ===
        <input
          type={inputType}
          name={id}
          id={id}
          defaultValue={value}
          className={
            (error
              ? "block py-3.5 px-4 w-full text-red_error bg-transparent border-2 border-red_error rounded-md appearance-none focus:outline-none focus:ring-0 focus:border-red_error peer"
              : "block py-3.5 px-4 w-full text-gray-900 bg-transparent border-2 border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-0 focus:border-blue-900 peer") +
            " " + AppendClassName
          }
          placeholder=" "
          required={required}
          onChange={onChange}
          disabled={!enabled}
          onClick={onClick}
        />
      )}

      {/* Etiqueta flotante */}
      <label
        htmlFor={id}
        className={
          error
            ? "peer-focus:font-medium absolute text-red_error duration-300 transform -translate-y-6 scale-75 top-4 left-4 origin-[0] peer-focus:left-4 peer-focus:text-red_error bg-white px-1 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            : "peer-focus:font-medium absolute text-gray-500 duration-300 transform -translate-y-6 scale-75 top-4 left-4 origin-[0] peer-focus:left-4 peer-focus:text-blue-900 bg-white px-1 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
        }
      >
        {text}
      </label>

      {/* Iconos (password / personalizados) */}
      {Icon && type !== "password" && (
        <div className="absolute right-4 top-4 text-gray-600">
          <Icon />
        </div>
      )}
      {type === 'password' && (
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute right-4 top-4 text-gray-600"
        >
          <img
            src={visibilityIcon}
            alt="Toggle visibility"
            className="w-6 h-6"
          />
        </button>
      )}

      {/* Mensaje de error */}
      {error && (
        <div className="relative pb-1">
          <span className="px-1 absolute text-red_error">
            {error}
          </span>
        </div>
      )}

      {/* Desplegable para rango de fechas */}
      {isDateRangeOpen && (
        <div className="absolute z-50 mt-2 w-full bg-white border border-gray-300 rounded shadow-lg">
          <DateRangePicker
            onChange={handleDateRangeChange}
            closeWindow={() => setDateRangeOpen(false)}
            options={dateRangeOptions}
            addRanges={addedRanges}
          />
        </div>
      )}
    </div>
  );
}
